module.exports = __webpack_public_path__ + "media/roomBgm.39477bdc.mp3";